import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import {
  NotificationBannerService,
  NotificationBannerMessage,
} from '@services';

@Component({
  selector: 'digicem-notification-banner',
  templateUrl: './notification-banner.component.html',
})
export class NotificationBannerComponent implements OnInit, OnDestroy {
  protected banner: NotificationBannerMessage | null = null;
  protected show = false;

  private sub!: Subscription;

  constructor(private notificationBannerService: NotificationBannerService) {}

  ngOnInit(): void {
    this.sub = this.notificationBannerService.banner$.subscribe(banner => {
      this.banner = banner;
      this.show = true;
      timer(4200).subscribe(() => (this.show = false));
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
